var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlaneRainbow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20106_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.04 20.0005C30.0394 19.8159 29.9877 19.6349 29.8906 19.4779C29.7935 19.3208 29.6549 19.1936 29.49 19.1105L23.37 16.0505V12.0505C23.37 11.2337 23.0455 10.4502 22.4678 9.87263C21.8902 9.29502 21.1068 8.97052 20.29 8.97052C19.4731 8.97052 18.6897 9.29502 18.1121 9.87263C17.5345 10.4502 17.21 11.2337 17.21 12.0505V16.0505L11.09 19.1105C10.925 19.1936 10.7864 19.3208 10.6893 19.4779C10.5922 19.6349 10.5405 19.8159 10.54 20.0005V23.3305C10.5386 23.4934 10.5771 23.6542 10.652 23.7989C10.7269 23.9435 10.8361 24.0677 10.97 24.1605C11.1031 24.2517 11.2562 24.3093 11.4164 24.3285C11.5766 24.3477 11.7391 24.3278 11.89 24.2705L17.21 22.2705V26.0005L15.39 26.6005C15.1913 26.6676 15.0188 26.7954 14.8968 26.9659C14.7748 27.1364 14.7094 27.3409 14.71 27.5505V30.0005C14.7105 30.1328 14.7373 30.2637 14.7888 30.3856C14.8403 30.5075 14.9155 30.6179 15.01 30.7105C15.1962 30.8953 15.4476 30.9994 15.71 31.0005H24.88C25.1452 31.0005 25.3995 30.8952 25.5871 30.7076C25.7746 30.5201 25.88 30.2657 25.88 30.0005V27.5005C25.8805 27.2909 25.8151 27.0864 25.6931 26.9159C25.5711 26.7454 25.3986 26.6176 25.2 26.5505L23.37 26.0005V22.2805L28.69 24.2805C28.8408 24.3378 29.0033 24.3577 29.1635 24.3385C29.3237 24.3193 29.4769 24.2617 29.61 24.1705C29.7438 24.0777 29.853 23.9535 29.9279 23.8089C30.0028 23.6642 30.0413 23.5034 30.04 23.3405V20.0005ZM22.73 19.9005C22.5777 19.8416 22.4134 19.8208 22.2513 19.8399C22.0892 19.8591 21.9342 19.9177 21.8 20.0105C21.6675 20.1024 21.5592 20.225 21.4843 20.3678C21.4095 20.5105 21.3702 20.6693 21.37 20.8305V26.6705C21.3701 26.8814 21.4369 27.0868 21.5608 27.2575C21.6848 27.4281 21.8595 27.5551 22.06 27.6205L23.87 28.2205V29.0005H16.7V28.2205L18.51 27.6205C18.7104 27.5551 18.8851 27.4281 19.0091 27.2575C19.133 27.0868 19.1998 26.8814 19.2 26.6705V20.8305C19.1997 20.6693 19.1604 20.5105 19.0856 20.3678C19.0107 20.225 18.9024 20.1024 18.77 20.0105C18.6357 19.9177 18.4807 19.8591 18.3186 19.8399C18.1565 19.8208 17.9922 19.8416 17.84 19.9005L12.53 21.9005V20.6205L18.64 17.5605C18.8067 17.4788 18.9475 17.3523 19.0464 17.1951C19.1453 17.0379 19.1985 16.8562 19.2 16.6705V12.0805C19.2 11.7941 19.3137 11.5194 19.5163 11.3168C19.7188 11.1143 19.9935 11.0005 20.28 11.0005C20.5664 11.0005 20.8411 11.1143 21.0436 11.3168C21.2462 11.5194 21.36 11.7941 21.36 12.0805V16.6705C21.3614 16.8562 21.4146 17.0379 21.5135 17.1951C21.6124 17.3523 21.7532 17.4788 21.92 17.5605L28.03 20.6205V21.8905L22.73 19.9005Z",
    fill: "#F2F2F2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.2727,
    stroke: "url(#paint0_linear_20106_219)",
    strokeWidth: 1.45455,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20106_219",
    x1: 43.0612,
    y1: 41.1987,
    x2: -9.21914e-8,
    y2: 41.1987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F3795E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E4BC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#39D68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#37B1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#874FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05576"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20106_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.28979 8.00031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaneRainbow);
export default __webpack_public_path__ + "static/media/icon-plane-rainbow.cb040a8d5ba3026db62394ec240c39d1.svg";
export { ForwardRef as ReactComponent };